import requestInstance from "./Request";
import { API_ENDPOINT } from "./Api";

let env = process.env.REACT_APP_API_BASE_URL;

// GET SubVendor Compliance Expiry Tracker
export const getSubVendorComplianceExpiryTracker = async ({
  complianceType = "subVendorRegistration",
  status = "",
  dateFrom = "",
  dateTo = "",
  page,
  pageSize,
  location = ""
} = {}) => {
  try {
    const response = await requestInstance.get(
      `${env}/admin-api/v3/expiring-compliances`, 
      {
        params: {
          complianceType,
          status,
          dateFrom,
          dateTo,
          page,
          pageSize,
          location,
          isB2B:'false'
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching SubVendor Compliance Expiry Tracker:", error);
    throw error;
  }
};
